"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

// This Context is publicly available,
// You only need this if you want to "update authentication", for example login a user and heck the user is authenticated without doing a full page refresh
var BootstrapperContext = _react["default"].createContext({
  analyticsService: {},
  store: {}
});

var _default = BootstrapperContext;
exports["default"] = _default;